export default {"src":"/_next/static/media/whoop-logo-round.5cef08c0.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};